import './GoodsList.scss';
import { items } from '../../../mockData/NPK-data';
import ItemNPK from '../../../Item/ItemNPK';
import React from 'react';

export default class GoodsList extends React.Component {
  constructor(props) {
    super(props);
    this.items = items;
  }

  render() {
    return (
      <div className="goods">
        {this.items.map(item => (
          <ItemNPK
            key={item.id}
            isNew={item.isNew}
            link={item.link}
            inside={item.inside}
            title={item.title}
            InStock={item.InStock}
            priceFirst={item.priceFirst}
            priceSecond={item.priceSecond}
            imgUrl={item.imgUrl}
            id={item.id}
          />
        ))}
      </div>
    );
  }
}